export interface AuthorizedTrader {
  name: string
  tradingAuthorityCode: TradingAuthorityCode
  discretionaryAuthorizationExpDate: string
  hasDiscretionaryAuthority: boolean
}

export enum TradingAuthorityCode {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
}
